module.exports = __webpack_public_path__ + "static/media/manager-r-7.f308edea.png";